import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedRoutingModule} from './shared-routing.module';
import {HomeBlockComponent} from './components/home-block/home-block.component';
import {MatIconModule} from '@angular/material/icon';
import {TranslateModule} from '@ngx-translate/core';
import {TableauComponent} from './generic/components/tableau/tableau.component';
import {MatTableModule} from '@angular/material/table';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatSortModule} from '@angular/material/sort';
import {MatInputModule} from '@angular/material/input';
import {MatTooltipModule} from '@angular/material/tooltip';
import {FormInputComponent} from './components/form-input/form-input/form-input.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatRadioModule} from '@angular/material/radio';
import {FormInputErrorComponent} from './components/form-input/form-input-error/form-input-error.component';
import {MatSelectModule} from '@angular/material/select';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatChipsModule} from '@angular/material/chips';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {SpinnerComponent} from './components/spinner/spinner.component';
import {FormErrorsComponent} from './components/form-errors/form.errors.component';
import {ErrorComponent} from './components/error/error.component';
import {SafeHtmlPipe} from './components/error/safe.html.pipe';
import {ErrorHandlerService} from './handlers/errors/error.handler.service';
import {ErrorService} from './services/error.service';
import {MatMenuModule} from '@angular/material/menu';
import {InformationComponent} from './modals/information/information.component';
import {TableauDiffuseurComponent} from './generic/components/tableaudiffuseur/tableau.component';
import {StarPreferenceComponent} from './components/star-preference/star-preference.component';
import {SelectPreferenceComponent} from './modals/select-preference/select-preference.component';
import {HttpService} from './services/http.service';
import {PresseSpecialiseComponent} from './modals/presse-specialise/presse-specialise.component';
import {BottomPageComponent} from './generic/components/bottom-page/bottom-page.component';
import {TopTablePageComponent} from './generic/components/top-table-page/top-table-page.component';
import {OtherOptionComponent} from './modals/other-option/other-option.component';
import {TableauActionComponent} from './generic/components/tableauAction/tableauAction.component';
import {AccessDeniedComponent} from './components/access-denied/access-denied.component';
import {ProfilesComponent} from '../administration/profiles/profiles.component';
import {EformErrorNoClikableComponent} from './components/eform-error-no-clikable/eform-error-no-clikable.component';
import {LierConsultationPlaceModalComponent} from './modals/lier-consultation-place-modal/lier-consultation-place-modal.component';
import {HistoRefConsultModalComponent} from './modals/histo-ref-consult-modal/histo-ref-consult-modal.component';

//import { OtherOptionComponent } from './modals/other-option/other-option.component';

@NgModule({
  declarations: [
    HomeBlockComponent,
    TableauComponent,
    TableauDiffuseurComponent,
    FormInputComponent,
    FormInputErrorComponent,
    SpinnerComponent,
    FormErrorsComponent,
    ErrorComponent,
    SafeHtmlPipe,
    InformationComponent,
    StarPreferenceComponent,
    SelectPreferenceComponent,
    PresseSpecialiseComponent,
    BottomPageComponent,
    TopTablePageComponent,
    OtherOptionComponent,
    TableauActionComponent,
    AccessDeniedComponent,
    ProfilesComponent,
    EformErrorNoClikableComponent,
    LierConsultationPlaceModalComponent,
    HistoRefConsultModalComponent

  ],
  imports: [
    CommonModule,
    SharedRoutingModule,
    MatIconModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    TranslateModule,
    MatTooltipModule,
    ReactiveFormsModule,
    MatRadioModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    FormsModule
  ],
  exports: [
    HomeBlockComponent,
    TranslateModule,
    TableauComponent,
    TableauDiffuseurComponent,
    FormInputComponent,
    FormInputErrorComponent,
    FormErrorsComponent,
    ErrorComponent,
    StarPreferenceComponent,
    PresseSpecialiseComponent,
    BottomPageComponent,
    TopTablePageComponent,
    TableauActionComponent,
    ProfilesComponent,
    EformErrorNoClikableComponent

  ],
  providers: [ErrorHandlerService, ErrorService, HttpService],
})
export class SharedModule {
}
